<div class="moodpickers">
    <tm-emoji-picker (onAddElement)="addEmoji($event)"></tm-emoji-picker>
    <tm-gif-picker (onAddElement)="addGif($event)"></tm-gif-picker>
</div>